<template>
<div class="home">
<div class="homeContent mt30 flexBetton">
  <div class="banner">
    <!-- <el-carousel height="500px">
      <el-carousel-item v-for="(item, index) in homeData.chartList" :key="index">
        <img :src="item.img_url" class="homeBanner" alt="">
      </el-carousel-item>
    </el-carousel> -->
          <el-carousel height="450px" @change="handleChange">
        <el-carousel-item
          v-for="(item, index) in homeData.chartList"
          :key="index"
        >
          <img v-if="item.data_type === 'image'" @click="goLink(item.link_url)" :src="item.img_url" class="homeBanner" alt="" />
          <video v-else ref="videoRefs" :poster="item.extend_img_url" :src="item.img_url" class="homeBanner videoBanner" controls muted loop playsinline />
        </el-carousel-item>
      </el-carousel>
  </div>

  <div class="noticeDiv">

    <div class="noticeContent">
      <div class="noticeContentTop">
      <div class="noticeContentTopMore">
      <img src="@/assets/homeNoticeImg.png" class="homeNoticeImg" />
      </div>
      <div class="noticeContentTopMore" @click="goToNotice">
      <div class="homeNoticeMore">查看更多</div>
      <div>
      <img src="@/assets/homeRightArr.png" class="homeRightArr" />
      </div>
      </div>
      </div>

      <div class="noticeContentList" v-for="(notice,index) in homeData.noticeList" :key="index" @click="goToNoticeDetail(notice.id)">
      <div class="circle"></div>
      <div class="noticeTitle">{{notice.title}}</div>
      </div>
    </div>
  </div>
</div>

  <div >
    <div class="menuView" v-if="!hasToken">
          <div class="homeMenuRkDiv">
    <img src="@/assets/homeMenuRk.png" class="homeNoticeImg"/>
    </div>
    <div class="menuContent">

      <div class="menuItem" @click="goToLogin('first')">
        <div class="menuItemImg"> 

          <img src="@/assets/l1.png" class="menu1Img" alt="">
        </div>
        <div class="menuText">成果申报入口</div>
      </div>
      <div class="menuItem" @click="goToLogin('second')">
        <div class="menuItemImg"> 

          <img src="@/assets/l2.png" class="menu1Img" alt="">
        </div>
        <div class="menuText">推荐单位入口</div>
      </div>
      <div class="menuItem" @click="goToLogin('third')">
        <div class="menuItemImg"> 

          <img src="@/assets/l3.png" class="menu1Img" alt="">
        </div>
        <div class="menuText">推荐个人入口</div>
      </div>
      <div class="menuItem" @click="goToLogin('fourth')">
        <div class="menuItemImg"> 

          <img src="@/assets/l4.png" class="menu1Img" alt="">
        </div>
        <div class="menuText">评委专家入口</div>
      </div>
      <!-- <div class="menuItem" @click="goToLogin('first')">
        <img src="@/assets/menu1.png" class="menuImg" alt="">
        <div class="menuText">成果申报入口</div>
      </div>
      <div class="menuItem" @click="goToLogin('second')">
        <img src="@/assets/menu2.png" class="menuImg" alt="">
        <div class="menuText">推荐单位入口</div>
      </div>
      <div class="menuItem" @click="goToLogin('third')">
        <img src="@/assets/menu3.png" class="menuImg" alt="">
        <div class="menuText">推荐个人入口</div>
      </div>
      <div class="menuItem" @click="goToLogin('fourth')">
        <img src="@/assets/menu4.png" class="menuImg" alt="">
        <div class="menuText">评委专家入口</div>
      </div> -->

    </div>

  </div>

  <div class="sbjjDiv homeContent">
            <div class="homeMenuRkDiv">
    <img src="@/assets/homeLc.png" class="homeLc"/>
    </div>
    <div class="sbjjMenu">
    <div class="c11">
    <div class="sbjjBgTitle">推荐</div>
    <div class="sbjjBgSubTitle">推荐机构精选推荐</div>
    </div>
    <div class="c22">
        <div class="sbjjBgTitle">入围</div>
    <div class="sbjjBgSubTitle">专业工具专家评价</div>
    </div>
    <div class="c33">
        <div class="sbjjBgTitle">优胜</div>
    <div class="sbjjBgSubTitle">专业工具专家评价</div>
    </div>
    <div class="c44">
        <div class="sbjjBgTitle">延伸服务|合作服务</div>
    <div class="sbjjBgSubTitle">专委终审隆重推介</div>
    </div>
      <!-- <img src="@/assets/c22.png" class="c11" alt=""/>
      <img src="@/assets/c11.png" class="c11" alt=""/>
      <img src="@/assets/c33.png" class="c11" alt=""/>
      <img src="@/assets/c44.png" class="c11" alt=""/> -->
    </div>
    <!-- <div>
      <img src="@/assets/sbjjImgDiv.png" class="sbjjImgDiv" alt="">
    </div> -->
    <div class="sbjjContent">
      <div class="sbjjContentItem">
        <div>
          <img src="@/assets/c1.png" class="c1Img" alt="">
        </div>
        <div class="sbjjSubTitle">精准推送市场需求</div>
        </div>
        <div class="sbjjContentItem">
        <div>
          <img src="@/assets/c2.png" class="c1Img" alt="">
        </div>
        <div class="sbjjSubTitle">精彩推介科技成果</div>
        </div>
        <div class="sbjjContentItem">
        <div>
          <img src="@/assets/c3.png" class="c1Img" alt="">
        </div>
        <div class="sbjjSubTitle">专业化服务促转化</div>
        </div>
        <div class="sbjjContentItem">
        <div>
          <img src="@/assets/c4.png" class="c1Img" alt="">
        </div>
        <div  class="sbjjSubTitle">生态化赋能促落地</div>
        </div>
    </div>
    
    <!-- <div>
      <img src="@/assets/sbjj.png" class="sbjj" alt="">
    </div>
    <div>
      <img src="@/assets/sbjjImg.png" class="sbjjImg" alt="">
    </div> -->
  </div>
  <div>

  </div>
  </div>
  <div>

  </div>
<div class="listContent">
<div class="mb30 fileDiv">
<div >
<img src="@/assets/homeFile.png" class="homeNoticeImg" alt="">
</div>
      <div class="noticeContentTopMore" @click="goTofileDownload">
      <div class="homeNoticeMore">查看更多</div>
      <div>
      <img src="@/assets/homeRightArr.png" class="homeRightArr" />
      </div>
      </div>
</div>

<div class="fileListDiv">
<div class="fileListContent" v-for="(file,index) in homeData?.fileList" :key="index" @click="goToFileDownloadDetail(file.id)">
<div>
<img :src="getFileIcon(file.file_type)" class="homePdfImg" alt="">
</div>
<div>
<div class="fileTitle">{{file.title}}</div>
<div class="fileRemark">文件大小：{{file.file_size}} <span class="m5">更新时间：{{file.up_date}}</span>    下载次数：{{file.download_count}}</div>
</div>
<div>
<img src="@/assets/homeDown.png" class="homeDownImg" alt="">
</div>
</div>
</div>

</div>
  <!-- <div class="listContent">
    <div class="listLeftDiv">
      <div class="listHeader">
        <div class="listHeaderTitle">通知公告</div>
        <div class="listHeaderMore">
         <div @click="goToNotice">
          查看更多
         </div> 
         <div>
          <img src="@/assets/rightArr.png" class="rightArr" alt="">
         </div>
        </div>
      </div>
      <div class="bottomLine"></div>
      <div class="leftListContent" v-for="(notice,index) in homeData.noticeList" @click="goToNoticeDetail(notice.id)">
        <div class="leftListTitle">{{notice.title}}</div>
        <div class="leftListDate">{{notice.add_date}}</div>
      </div>
    </div>
    <div class="listLeftDiv">
      <div class="listHeader">
        <div class="listHeaderTitle">文件下载</div>
        <div class="listHeaderMore">
         <div @click="goTofileDownload">
          查看更多
         </div> 
         <div>
          <img src="@/assets/rightArr.png" class="rightArr" alt="">
         </div>
        </div>
      </div>
      <div class="bottomLine"></div>
      <div class="leftListContent"  v-for="(file,index) in homeData?.fileList" @click="goToFileDownloadDetail(file.id)">
        <div class="leftListTitle">{{file.title}}</div>
        <div class="leftListDate">{{file.add_date}}</div>
      </div>
    </div>
  </div> -->
</div>
</template>

<script>

export default {
  name: "Home",
  data() {
    return {
      hasToken:false,
      homeData:{}
    };
  },
  computed: {
    getFileIcon() {
      return (type) => type === 'pdf' ? require('@/assets/homePdf.png') : require('@/assets/homeWord.png');
    }
  },
  mounted() {
  this.hasToken = !!sessionStorage.getItem('token')
    this.getHomeData();
  },

  methods: {
    goLink(url){
      window.open(url, '_blank');
    },
        handleChange() {
      const videos = this.$refs.videoRefs;
      if (videos) {
        const videoList = Array.isArray(videos) ? videos : [videos];
        videoList.forEach((video) => {
          if (video) {
            video.pause();
          }
        });
      }
    },
    getHomeData(){
      this.$API.getHomeList().then(res => {
        this.homeData = res.data
    })
    },

    goToLogin(tabName){
      this.$router.push({ path: "/Login", query: { activeName: tabName }});
    },

    goToNoticeDetail(id){
      this.$router.push({ path: "/NoticeDetail", query: { id: id }});
    },
    goToFileDownloadDetail(id){
      this.$router.push({ path: "/FileDownloadDetail", query: { id: id }});
    },
    goToNotice(){
      this.$router.push({ path: "/Notice"});
    },
    goTofileDownload(){
      this.$router.push({ path: "/FileDownload"});
    }
}
}
</script>

<style scoped lang="less">
.fileDiv{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.m5{
  margin: 0 12px;
}
.fileListDiv{
  display: flex;
  flex-wrap: wrap;
}
.fileRemark{
  width: 396px;
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #999999;
margin-top: 10px;
}
.fileTitle{
  width: 405px;
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: bold;
font-size: 16px;
color: #444444;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

}
.mb30{
  margin-bottom: 30px;
}
.fileListContent{
  width: 585px;
height: 110px;
background: #FFFFFF;
box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.08);
border-radius: 4px 4px 4px 4px;
display: flex;
justify-content: space-between;
align-items: center;
padding: 30px 24px;
margin-bottom: 20px;
cursor: pointer;
}
.fileListContent:nth-child(2n){
  margin-left: 30px;
}
.homePdfImg{
  width: 38px;
  height: 50px;
}
.homeDownImg{
  width: 46px;
  height: 46px;
}
.sbjjBgTitle{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: bold;
font-size: 16px;
color: #FFFFFF;

}
.sbjjBgSubTitle{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #FFFFFF;
margin-top: 5px;
}
.sbjjMenu{
  display: flex;
}

.c11{
  width: 300px;
  height: 80px;
  background: url('../../assets/c22.png') no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 55px;
}
.c22{
  width: 300px;
  height: 80px;
  background: url('../../assets/c11.png') no-repeat center center;
  background-size: 100% 100%;
    display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 55px;
}
.c33{
  width: 300px;
  height: 80px;
  background: url('../../assets/c33.png') no-repeat center center;
  background-size: 100% 100%;
    display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 55px;
}
.c44{
  width: 300px;
  height: 80px;
  background: url('../../assets/c44.png') no-repeat center center;
  background-size: 100% 100%;
    display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 55px;
}
.homeLc{
  width: 242px;
  height: 29px;
  margin-top: 40px;
}
.homeMenuRkDiv{
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 34px;
}
::v-deep .el-carousel__button{
  height: 6px !important;
  width: 30px !important;
background: #FFFFFF;
border-radius: 4px 4px 4px 4px;
}
.noticeTitle{
  width: 369px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;



font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 16px;
color: #444444;
line-height: 24px;
cursor: pointer;
&:hover{
  color: #0366F1;
}
}
.noticeContentList{
  display: flex;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #EEEEEE;
}
.noticeContentList .circle{
  flex-shrink: 0;
  margin-right: 10px;
}
.noticeContentList .noticeTitle{
  flex: 1;
}
.circle{
  width: 4px;
height: 4px;
background: #ACACAC;
border-radius: 50%;
}
.noticeContentTop{
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.homeNoticeMore{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 16px;
color: #2F86FF;
margin-right: 5px;
cursor: pointer;
}
.noticeContentTopMore{
  display: flex;
  align-items: center;
}
.homeRightArr{
  width: 7px;
  height: 12px;
}
.homeNoticeImg{
  width: 110px;
  height: 29px;
}
.noticeContent{
  width: 447px;
height: 450px;
background: linear-gradient( 359deg, #FFFFFF 0%, #EDF5FF 100%);
box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.05);
border-radius: 4px 4px 4px 4px;
padding: 27px;
}
.flexBetton{
  display: flex;
  justify-content: space-between;
}
.mt30{
  padding-top: 30px !important;
}
    .videoBanner{
    background-color: #000;
  }
.sbjjSubTitle{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 18px;
color: #444444;
line-height: 24px;
text-align: center;
margin-top: 15px;
}
.c1Img{
  width: 100%;
  height: 150px;
}
.sbjjContentItem{
  width: 260px;
height: 220px;
background: #FFFFFF;
}
.sbjjContent{
  width: 100%;
height: 292px;
background: #F5F7FA;
margin-top: 10px;
display: flex;
justify-content: space-around;
align-items: center;
}
.sbjjTitle{
font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
font-weight: 500;
font-size: 30px;
color: #393939;
margin-top: 40px;
}
.menu4Img{
  width: 88px;
  height: 106px;
}
.menu3Img{
  width: 102px;
  height: 99px;
}
.menu2Img{
  width: 102px;
  height: 94px;
}
.menu1Img{
  width: 90px;
  height: 90px;
}
.leftListDate{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #707070;
width: 20%;
text-align: right;
}
.leftListTitle{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #333333;
width: 80%;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
}
.leftListContent{
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}
.leftListTitle:hover{
  color: #2f86ff !important;
}
.bottomLine{
  width: 40px;
height: 4px;
background: #2F86FF;
border-radius: 0px 0px 0px 0px;
margin-top: 5px;
}
.listHeaderTitle{
font-family: Source Han Sans CN, Source Han Sans CN;
font-weight: bold;
font-size: 26px;
color: #393939;

}
.rightArr{
  margin-left: 7px;
}
.listHeaderMore{
  display: flex;
  align-items: center;
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #2F86FF;

}
.listHeader{
display: flex;
justify-content: space-between;
align-items: center;
}
.listContent{
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 30px;
  margin-top: 44px  ;
}
.listLeftDiv{
  width: 47%;
  cursor: pointer;
}
.listRightDiv{
  width: 47%;
  cursor: pointer;
}
.sbjjImgDiv{
  width: 100%;
  height: 80px;
  margin-top: 15px;
}
.sbjj{
  width: 120px;
  height: 55px;
}
.sbjjImg{
  width: 100%;
  height: 625px;
  margin-top: 20px;
}
.menuText{
width: 108px;
height: 24px;
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: bold;
font-size: 18px;
color: #333333;
text-align: center;
margin-top: 22px;

}
.menuItem{
  position: relative;
  width: 288px;
height: 200px;
background: url('../../assets/loginMenuBg.png') no-repeat;
background-size: 100% 100%;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
}

.homeContent{
  width: 1200px;
  margin: 0 auto;
}
.home {
  background: #fff;
  .banner {
    width: 723px;
    height: 450px;
    .homeBanner {
      width: 100%;
      height: 450px;
    }
  }
  .declare{
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
    justify-content: center;
    width: 204px;
    height: 98px;
    background: #fff;
    box-shadow: 0 2px 12px 0 #ddd;
    border-radius: 4px;
    margin-bottom: 5px;
  }
  .menuContent{
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    width: 1200px;
    margin: 0 auto;
  }
  .menuView{
    background: url('../../assets/homeLoginBg.png') no-repeat;
    background-size: 100% 100%;
    height: 380px;
    display: flex;
    flex-direction: column;
    padding: 59px 0 58px 0;
    margin-top: 40px;
    .menuImg{
    width: 275px;
    height: 132px;
    cursor: pointer;
    }
    .line{
      width: 1px;
    height: 35px;
    border-right: 1px solid #ddd;
    margin:0 8px;
    }
    .menu5Img{
      width: 42px;
      height: 42px;
      cursor: pointer;
    }
  }
}
</style>
